module.exports = __webpack_public_path__ + "img/grup copy.e1f1c150.svg";